// TUT-512 — o perfil do escritório: ler e salvar os dados, enviar e remover
// os dois logos, e a URL do logo da sessão (barra, impressão, portal).
import { demoApi } from "../demo-data";
import type { EntradaDoPerfil, PerfilDoEscritorio, Session, VarianteDoLogo } from "../types";
import { request } from "./infra";

// Lido aqui, e não importado: o empacotador só dobra a constante no módulo
// que a escreve, e é isso que tira o demo do build de produção (TUT-448).
const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

export const apiDoPerfilDoEscritorio = {
  perfilDoEscritorio(): Promise<PerfilDoEscritorio> {
    return useDemoApi ? demoApi.perfilDoEscritorio() : request<PerfilDoEscritorio>("/tenant-profile");
  },
  salvarPerfilDoEscritorio(entrada: EntradaDoPerfil): Promise<PerfilDoEscritorio> {
    return useDemoApi
      ? demoApi.salvarPerfilDoEscritorio(entrada)
      : request<PerfilDoEscritorio>("/tenant-profile", { method: "PUT", body: JSON.stringify(entrada) });
  },
  enviarLogoDoEscritorio(variante: VarianteDoLogo, contentBase64: string, dataUrl: string): Promise<PerfilDoEscritorio> {
    return useDemoApi
      ? demoApi.enviarLogoDoEscritorio(variante, contentBase64, dataUrl)
      : request<PerfilDoEscritorio>(`/tenant-profile/logo/${variante}`, {
          method: "PUT",
          body: JSON.stringify({ contentBase64 }),
        });
  },
  removerLogoDoEscritorio(variante: VarianteDoLogo): Promise<PerfilDoEscritorio> {
    return useDemoApi
      ? demoApi.removerLogoDoEscritorio(variante)
      : request<PerfilDoEscritorio>(`/tenant-profile/logo/${variante}`, { method: "DELETE" });
  },
};

/**
 * A URL do logo do escritório da sessão, ou `null` sem logo. A versão
 * (`sha256`) vai na URL: logo novo é URL nova, e o navegador guarda a imagem
 * sem perguntar de novo. Quem está no portal lê pela rota do portal.
 */
export function urlDoLogoDoEscritorio(
  session: Session | null | undefined,
  variante: VarianteDoLogo,
): string | null {
  const versao = session?.tenant.logo?.[variante];
  if (!session || !versao) return null;
  if (useDemoApi) return demoApi.urlDoLogoDoDemo(variante);
  const base = session.user.roleKey === "EXTERNAL" ? "/api/portal/logo" : "/api/tenant-profile/logo";
  return `${base}/${variante}?v=${versao}`;
}

/** O nome que o escritório mostra (o perfil), e o da conta em sessão antiga. */
export function nomeDoEscritorio(session: Session | null | undefined): string {
  return session?.tenant.displayName || session?.tenant.name || "";
}
